// Exercise
export const SHOW_EXERCISE = 'SHOW_EXERCISE';
export const SHOW_SOLUTION = 'SHOW_SOLUTION';
export const UPDATE_LOST_XP = 'UPDATE_LOST_XP';
export const CHECK_EXERCISE = 'CHECK_EXERCISE';
export const SET_COURSE_LICENSE_STATUS = 'SET_COURSE_LICENSE_STATUS';
export const SET_CHOICE = 'SET_CHOICE';
export const EXERCISE_ENTITY_UPDATED = 'EXERCISE_ENTITY_UPDATED';